import { Link } from "@tanstack/react-router";
import { motion } from "framer-motion";
import { services } from "@/data";
import { staggerOrchestrator, cardItem } from "@/lib/animations/variants";

export function ServicesSection() {
  return (
    <section className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16"
        >
          <div className="max-w-xl">
            <h2 className="text-4xl md:text-5xl font-bold leading-tight max-w-xl mb-6">
              Our Services
            </h2>
            <p className="text-lg text-neutral-800 leading-relaxed">
              We provide comprehensive tax, accounting, compliance, and business advisory services, helping individuals and businesses navigate Kenya's regulatory landscape with confidence.
            </p>
          </div>

          <div className="mt-6 lg:mt-0 lg:ml-6 flex-shrink-0">
            <Link
              to="/services"
              className="inline-flex items-center gap-2 px-7 py-3.5 border-2 border-burgundy text-burgundy font-semibold rounded-xl hover:bg-burgundy hover:text-white transition-all"
            >
              View All Services
              <span className="text-lg leading-none transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </Link>
          </div>
        </motion.div>

        <motion.div
          variants={staggerOrchestrator(0.07, 0.1)}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, margin: "-60px" }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {services.slice(0, 6).map((service) => (
            <motion.div key={service.id} variants={cardItem}>
              <Link
                to={`/services/${service.slug}` as never}
                className="group relative block h-80 rounded-xl overflow-hidden"
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-xl font-semibold mb-2 leading-tight">
                    {service.title}
                  </h3>
                  <p className="text-sm text-white/80 line-clamp-3 leading-relaxed">
                    {service.shortDescription}
                  </p>
                  <span className="inline-block mt-3 text-xs font-medium tracking-wider uppercase text-gold-light border-b border-gold-light/0 group-hover:border-gold-light/80 transition-all duration-300">
                    Learn More
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}